import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import useForm from 'hooks/useForm'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import { authenticationKinds } from '../constants'
import styles from '../MultiStepPMSLogin.module.scss'

const DirectClientCredentials = ({ setUpdateConfig }) => {
  const { addToast } = useToasts()
  const [formData, handleFormChange] = useForm({
    hubId: '',
    enterpriseId: '',
    propertyId: '',
    clientId: '',
    clientSecret: '',
    gatewayUrl: '',
    authenticationKind: authenticationKinds.direct,
    step: 'Step1PartnerRegistration'
  })

  const handleFormSubmission = e => {
    e.preventDefault()
    pmsApi
      .setOhipConfiguration(formData)
      .then(() => {
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
        setUpdateConfig(prev => prev + 1)
      })
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  return (
    <div className={styles.stepActions}>
      <form className={styles.actionContainer} onSubmit={handleFormSubmission}>
        {[
          ['hubId', 'Hub id'],
          ['enterpriseId', 'Enterprise id'],
          ['propertyId', 'Property id'],
          ['clientId', 'Client id'],
          ['clientSecret', 'Client secret'],
          ['gatewayUrl', 'Gateway URL']
        ].map(([name, label]) => (
          <div className={styles.inputContainer} key={name}>
            <TextInput
              name={name}
              className={styles.textInput}
              type={name === 'clientSecret' ? 'password' : 'string'}
              label={label}
              value={formData[name]}
              onChange={handleFormChange}
              autoComplete="off"
              required
            />
          </div>
        ))}
        <div className={styles.inputContainer}>
          <PrimarySmallButton type="submit" size="small">
            Save & test
          </PrimarySmallButton>
        </div>
      </form>
    </div>
  )
}

export default DirectClientCredentials
